export default class OrderStatusPolling {
  constructor({ pollAction, normalPollingIntervalMs, timesPolledLimit } = {}) {
    this.timesPolled = 0;
    this.normalPollingIntervalMs = normalPollingIntervalMs || 5000;
    this.timesPolledLimit = timesPolledLimit || 6;
    this.pollAction = pollAction;
  }

  getTimesPolled() {
    return this.timesPolled;
  }

  setTimesPolled(amount) {
    this.timesPolled = amount;
  }

  onUpdate({ error, shouldResetPoll } = {}) {
    const statusCode = error && error.statusCode;
    const unauthenticatedUser = statusCode === 401;

    const tooManyPollRequests = statusCode === 429;

    this.resetPollTimer();

    if (unauthenticatedUser) {
      this.redirectToHomePage();
    }

    if (tooManyPollRequests) {
      this.forceStopPollPastLimit();
    }

    if (this.isUnderPollLimit() && !tooManyPollRequests) {
      this.poll(shouldResetPoll);
    }
  }

  poll(shouldResetPoll = false) {
    this.timer = setTimeout(() => {
      if (this.pollAction) {
        this.pollAction();
      }

      if (shouldResetPoll) {
        this.resetTimesPolled();
      } else {
        this.updateTimesPolled();
      }
    }, this.normalPollingIntervalMs);
  }

  updateTimesPolled() {
    this.setTimesPolled(this.getTimesPolled() + 1);
  }

  forceStopPollPastLimit() {
    this.setTimesPolled(this.timesPolledLimit);
    this.resetPollTimer();

    if (this.pollAction) {
      this.pollAction();
    }
  }

  resetTimesPolled() {
    this.setTimesPolled(0);
  }

  isUnderPollLimit() {
    return this.getTimesPolled() < this.timesPolledLimit;
  }

  isPollingAndUnderPollLimit() {
    return this.getTimesPolled() > 0 && this.getTimesPolled() < this.timesPolledLimit;
  }

  isOverPollLimit() {
    return this.getTimesPolled() >= this.timesPolledLimit;
  }

  resetPollTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  unmount() {
    this.resetPollTimer();
  }

  redirectToHomePage() {
    if (typeof window !== 'undefined') {
      window.location.href = '/';
    }
  }
}
